// const getEnv = () => 'narwhal';
// const getEnv = () => (process.env.NODE_ENV === 'production' ? (window.location.origin).split('.')[1] : 'kartbkart');
const getEnv = () => (process.env.NODE_ENV === 'production' ? (window.location.origin).split('.')[1] : 'satrex');
export default getEnv;
